import Service from './Service';
import {get} from '-/util/lodash';

const CREDITOR_SETDATA = 'CREDITOR_SETDATA';
const reducerName = 'creditor';
const reducer = (state = {}, action) => {
    const {type, payload} = action;
    switch (type) {
        case CREDITOR_SETDATA: {
            return {
                ...state,
                ...payload
            };
        }
    }
    return state;
};

class CreditorService extends Service {
    constructor() {
        super();

        if (!CreditorService.instance) {
            CreditorService.instance = this;
        }
        return CreditorService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    setData(creditor) {
        this.store.dispatch({
            type: CREDITOR_SETDATA,
            payload: creditor
        });
    }

    getBranches() {
        return this.getReducerState().branches || [];
    }

    getName() {
        return this.getReducerState().name || '';
    }

    getOptInMessage() {
        return this.getReducerState().optInMessage || '';
    }

    getYearsWorkHistoryRequired() {
        return this.getReducerState().workHistoryYears || 0;
    }

    getYearsResidencyHistoryRequired() {
        return this.getReducerState().residencyHistoryYears || 0;
    }

    getRequireBookoutConfirmation() {
        return this.getReducerState().requireBookoutConfirmation || false;
    }

    getRequireCitizenshipProof() {
        return this.getReducerState().requireCitizenshipProof || false;
    }

    getRequirePriorMembershipAnswer() {
        return get(this.getReducerState(), 'requirePriorMembershipAnswer.isActive', false);
    }

    getPriorMembershipQuestion() {
        return get(this.getReducerState(), 'requirePriorMembershipAnswer.question');
    }

    getPositionForRetirementRequired() {
        return this.getReducerState().requirePositionForRetirement || false;
    }

    getTheme() {
        return this.getReducerState().theme || null;
    }

    getSalespeople() {
        return this.getReducerState().salespeople || [];
    }

    getSelfEmploymentVerification() {
        return this.getReducerState().selfEmploymentVerification;
    }

    getGrossIncomeThreshold() {
        const {grossIncomeThreshold} = this.getReducerState();
        const {isActive, value} = grossIncomeThreshold || {};

        return isActive ? value : null;
    }

    getGeolocationCoordinates() {
        const {geolocation} = this.getReducerState();

        return geolocation;
    }
}

export default new CreditorService();
